import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Form,
  Input,
  Button,
  Layout,
  Select,
  Image,
  Modal,
  InputNumber,
  Card,
} from "antd";
import { FaArrowLeft } from "react-icons/fa";
import { Get } from "../../config/api/get";
import {
  QUESTION, COURSE,
  QUIZ,
  LECTURES
} from "../../config/constants/api";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import swal from "sweetalert";
import { ImageUrl } from "../../helpers/Functions";
import "../upcoming-lessons/upcoming-lessons.css";
import "../course-management/course-management.css";
import "./quiz-details.css";

const { Option } = Select;


function QuizAdd() {
  const [form] = Form.useForm(); // Create form instance

  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const userData = useSelector((state) => state.user.userData);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState(null);
  const [course, setCourse] = useState([]);
  const [, setEditMode] = useState(false);
  const [, setImageNew] = useState();
  const [students, setStudents] = useState([]);
  const [lectures, setLectures] = useState([]);

  useEffect(() => {
    getCourses();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getCourses = async () => {
    setLoading(true);
    const res = await Get(`${COURSE.getAllCourses}`, token, {
      limit: "100",
      createdBy : userData?._id
    });

    setCourse(res.data.docs);
    setLoading(false);
  };
  console.log(course,';course')
  const handleStatus = async () => {
    try {
      await Get(
        QUESTION.toggleStatus + "/" + question._id,
        token,
        {}
      );
      const newUser = { ...question };

      newUser.isActive = !question.isActive;
      setModalOpen(false);
      setQuestion(newUser);
    } catch (error) {
      console.log(error.message);
    }
  };

  const onFinish = (values) => {
    setLoading(true);
    let obj = { ...values, questions: [] };
    Post(QUIZ.addQuiz, obj, token, null)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          console.log(response?.data);

          swal("Success!", "Quiz Added Successfully", "success");
          navigate(-1);

          setEditMode(false);
          setImageNew();
        } else {
          setLoading(false);
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoading(false);
  };
  const handleCourseChange = async (courseId) => {
    // Fetch enrolled students
    const res = await Get(`${COURSE.getEnrolledStudens}${courseId}`, token);
    if (res.status) {
      setStudents(res?.data?.students);
    }
    
    // Fetch lectures for the selected course
    const lectureRes = await Get(`${LECTURES.getAllLecturesByCourse}${courseId}`, token);
    if (lectureRes.status) {
      setLectures(lectureRes?.data?.docs || []);
    } else {
      setLectures([]);
    }
    
    // Reset the form fields
    form.setFieldsValue({ students: [], lecture: undefined });
  };
  return (
    <Layout
      className="configuration upcoming-lessons-page quiz-details-page"
      style={{ minHeight: "100vh" }}
    >
      <Row className="blueBackground-old coursebnr quiz-details-hero">
        <Typography.Title
          level={1}
          className="fontFamily1 aboutbanner-content"
          style={{color:"#fff"}}
        >
          Add quiz
        </Typography.Title>
      </Row>

      <div className="boxDetails quiz-details-shell">
        <Card className="quiz-details-top-card" bordered={false}>
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24}>
              <div className="course-management-title-block">
                <button
                  type="button"
                  className="course-management-inline-back"
                  aria-label="Go back"
                  onClick={() => navigate(-1)}
                >
                  <FaArrowLeft aria-hidden="true" />
                </button>
                <Typography.Title
                  level={2}
                  className="fontFamily1 quiz-details-page-title"
                >
                  Add Quiz
                </Typography.Title>
              </div>
            </Col>
          </Row>
        </Card>

        <div className="quiz-details-panel">
              <Form
                className="quiz-details-form"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete={false}
                form={form}
              >
                <Row className="quiz-details-form-inner" gutter={[20, 20]} style={{ padding: "8px 0" }}>
                  <Col xs={24} md={18}>
                    <Row gutter={20}>
                      <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                          Name :
                        </Typography.Title>

                        <Form.Item
                          name={`title`}
                          style={{ width: "100%" }}
                          rules={[
                            {
                              required: true,
                              message: "Please insert Name",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            placeholder="Enter Name"
                            className="signupFormInput"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                          Course :
                        </Typography.Title>

                        <Form.Item
                          name="course"
                          initialValue={course?.course?._id}
                          style={{ width: "100%" }}
                          rules={[
                            {
                              required: true,
                              message: "Please select course course",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Course"
                            className="signupSelectBox"
                            onChange={handleCourseChange}
                          >
                            {course.map((item) => {
                              return (
                                <Option
                                  key={item._id}
                                  disabled={item.status !== "ACTIVE"}
                                  value={item._id}
                                >
                                  {item.title}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={20}>
                      {/* <Col
                  xs={24}
                  sm={12}
                  style={{ display: "flex", alignItems: "flex-start", flexDirection: 'column' }}
                >
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                    Due Date :
                  </Typography.Title>

                  <Form.Item
                    name={`quizDate`}
                    style={{ width: "100%" }}
                    rules={[
                      {
                        required: true,
                        message: "Please insert Due Date",
                      },
                    ]}
                  >
                    <DatePicker size="large"
                      placeholder="Enter Date"
                      className="signupFormInput"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col> */}

                      <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                          Lecture :
                        </Typography.Title>

                        <Form.Item
                          name="lecture"
                          style={{ width: "100%" }}
                          rules={[
                            {
                              required: true,
                              message: "Please select a lecture",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Lecture"
                            className="signupSelectBox"
                          >
                            {lectures.map((item, index) => {
                              return (
                                <Option key={item._id} value={item._id}>
                                  {item.title}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                          Select Students :
                        </Typography.Title>
                        <Form.Item name="students" style={{ width: "100%" }}>
                          <Select
                            mode="multiple"
                            allowClear
                            style={{
                              width: "100%",
                            }}
                            placeholder="Please select"
                            options={students.map((student) => ({
                              label: `${student.firstName} ${student.lastName}`, // Display Name
                              value: student._id, // Store _id on selection
                            }))}
                            className="custum-multiselect"
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                          Passing Percentage :
                        </Typography.Title>

                        <Form.Item
                          name="passingPercentage"
                          initialValue={course?.passingPercentage}
                          style={{ width: "100%" }}
                          rules={[
                            {
                              required: true,
                              message: "Please input Passing Percentage",
                            },
                          ]}
                        >
                          <InputNumber
                            size="large"
                            placeholder="Enter Passing Percentage"
                            className="signupFormInput"
                            min={0}
                            max={100}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={20}>
                      <Col xs={24} className="quiz-details-field-col">
                          <Typography.Title
                            level={5}
                            className="fontFamily1 quiz-details-field-label"
                          >
                          Description :
                        </Typography.Title>

                        <Form.Item
                          name="description"
                          style={{ width: "100%" }}
                          rules={[
                            {
                              required: true,
                              message: "Please input Description",
                            },
                          ]}
                        >
                          <Input
                            size="large"
                            placeholder="Enter Description"
                            className="signupFormInput"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} md={18}>
                    <Row gutter={20}>
                      <Col xs={24} className="quiz-details-field-col" style={{ paddingTop: 10 }}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="loginButton"
                          disabled={loading}
                        >
                          {loading ? "Loading..." : "Add Quiz"}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
        </div>
      </div>

      <Modal
        open={modalOpen}
        onOk={() => handleStatus()}
        onCancel={() => setModalOpen(false)}
        okText="Yes"
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "2px solid #2484c6",
            color: "#2484c6",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "#2484c6",
            color: "white",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid #2484c6",
          },
        }}
      >
        <Image
          // src="../images/question.png"
          src={ImageUrl("question.png")}
          preview={false}
          width={100}
          height={120}
        />
        <Typography.Title level={4} style={{ fontSize: "25px" }}>
          {question?.isActive ? "Deactivate" : "Activate"}
        </Typography.Title>
        <Typography.Text style={{ fontSize: 16 }}>
          Do You Want To {question?.isActive ? "Deactivate" : "Activate"} This
          User?
        </Typography.Text>
      </Modal>

      <br />
      <br />
    </Layout>
  );
}
export default QuizAdd;
